import { render, staticRenderFns } from "./Coins.vue?vue&type=template&id=b44602b4&scoped=true&"
import script from "./Coins.vue?vue&type=script&lang=js&"
export * from "./Coins.vue?vue&type=script&lang=js&"
import style0 from "./Coins.vue?vue&type=style&index=0&id=b44602b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44602b4",
  null
  
)

export default component.exports